<script setup lang="ts">
// PROPS
defineProps({
    hideBack: { type: Boolean, default: false },
});

// EVENTS
const emit = defineEmits(['back']);
</script>

<template>
    <div class="relative mb-8 flex h-[36px] items-center justify-center">
        <UButton v-if="!hideBack" class="absolute left-0" variant="ghost" square color="neutral" @click="emit('back')">
            <UIcon name="lucide:arrow-left" class="text-2xl" />
        </UButton>
        <SvgoFleequidLogo class="h-[20px]" :font-controlled="false" />
    </div>
</template>
